import { string, object } from 'yup';
import addDays from 'date-fns/addDays';
import differenceInYears from 'date-fns/differenceInYears';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isDate from 'date-fns/isDate';

export const BeneficiarySchema = object({
  key: string(),
  firstname: string(),
  lastname: string(),
  birthday: string()
    .test('isDate', '${birthday} is not a valid date', value =>
      isDate(parseISO(value))
    )
    .test(
      'isDate',
      'A birthday cannot be in the future',
      value => value <= format(addDays(Date.now(), 1), 'yyyy-MM-dd')
    ),
  country: string(),
  email: string()
    .nullable()
    .notRequired()
});

//export type Beneficiary = InferType<typeof BeneficiarySchema>;
export type Beneficiary = {
  key: string;
  firstname: string;
  lastname: string;
  birthday: string;
  country: string;
  email?: string;
};

export const Beneficiary = {
  withLocalDates: (beneficiary: Beneficiary, format: Function): object => {
    return {
      ...beneficiary,
      birthday: format(beneficiary.birthday)
    };
  },
  getAge: (beneficiary: Beneficiary): number => {
    return differenceInYears(Date.now(), parseISO(beneficiary.birthday));
  }
};

export const StaySchema = object({
  destination: string().required(),
  startDate: string().required(),
  endDate: string()
    .nullable()
    .notRequired()
}).test(
  'increasing-in-time',
  'la date de départ doit être antérieure au retour',
  value => (value.endDate ? value.startDate <= value.endDate : true)
);

export type Stay = {
  destination: string;
  startDate: string;
  endDate?: string;
};

export const Stay = {
  withLocalDates: (stay: Stay, format: Function): object => {
    if (stay.endDate) {
      return {
        ...stay,
        startDate: format(stay.startDate),
        endDate: format(stay.endDate)
      };
    } else
      return {
        ...stay,
        startDate: format(stay.startDate)
      };
  }
};

export type Country = {
  name: string;
  code: string;
  code2: string;
  label: string;
};
